var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBedSpace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97853 5.18779L5.96731 5.33557C5.94609 5.61491 5.67068 5.86266 5.39068 5.85429L5.24256 5.84988C4.84106 5.83785 4.48787 5.68338 4.24531 5.41369L3.10671 4.148C2.87821 3.89397 2.76131 3.55263 2.77443 3.17779L2.78162 2.97285C2.79187 2.68072 3.08556 2.41654 3.37715 2.43716L3.58168 2.45163C3.95581 2.4781 4.28293 2.63035 4.51143 2.88438L5.65 4.1501C5.89259 4.41975 6.00893 4.78729 5.97853 5.18779Z",
    stroke: "#8993A4",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77375 5.85449H1.1875V1.49793C1.1875 1.21621 1.41587 0.987867 1.69756 0.987867H2.26369C2.54537 0.987867 2.77375 1.21621 2.77375 1.49793V5.85449Z",
    stroke: "#8993A4",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92462 9.23064H16.5625V6.98129C16.5625 7.29126 16.3112 7.54251 16.0012 7.54251H6.545C6.235 7.54251 5.98375 7.29126 5.98375 6.98129V5.85439H1.1875V9.23064H4.17491",
    stroke: "#8993A4",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5633 6.31666C16.5633 5.91062 16.3392 5.53525 15.9777 5.35041C15.632 5.17359 15.0983 5.01828 14.2904 5.01828H5.98438V6.98166C5.98438 7.29166 6.23569 7.54297 6.54569 7.54297H16.002C16.312 7.54297 16.5633 7.29166 16.5633 6.98166V6.31666Z",
    stroke: "#8993A4",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1875 9.23062V11.4727H2.26609C2.26609 11.4727 2.41903 9.85572 3.22216 9.23062H1.1875Z",
    stroke: "#8993A4",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.562 9.23062V11.4727H15.4834C15.4834 11.4727 15.3304 9.85572 14.5273 9.23062H16.562Z",
    stroke: "#8993A4",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedSpace);
export default __webpack_public_path__ + "static/media/bed-space.dc0f22cc.svg";
export { ForwardRef as ReactComponent };